module.exports = __webpack_public_path__ + "img/DB1GLOBAL_LOGO.52bacda9.png";